import { Brain, Flower, Heart, Ribbon, Spark, User, Users } from "../icons";
import { Leaves } from "../layout";

export function Home() {
  const focus = [
    { icon: <Users />, title: "Individual Counselling", blurb: "One-on-one support for emotional well-being and personal growth." },
    { icon: <Spark />, title: "Holistic Wellness Support", blurb: "Nurturing mind, body, and spirit through integrated care." },
    { icon: <Ribbon />, title: "HIV / TB Psychosocial Support", blurb: "Compassionate care for those affected by chronic illness." },
  ];
  const services = [
    { icon: <Ribbon />, title: "Couples Counselling", blurb: "Support for couples navigating communication, trust, or conflict.", tone: "peach" },
    { icon: <Brain />, title: "Group Sessions", blurb: "Facilitated sessions for individuals with shared experiences or goals.", tone: "lavender" },
    { icon: <User />, title: "Individual Counselling", blurb: "One-on-one support for emotional well-being and personal growth.", tone: "sage" },
    { icon: <Heart />, title: "HIV Support", blurb: "Compassionate counselling for individuals affected by HIV.", tone: "peach" },
    { icon: <Flower />, title: "Wellness Support", blurb: "Holistic counselling to support mental, emotional and spiritual well-being.", tone: "sage" },
  ];
  return (
    <>
      <section className="hero">
        <Leaves />
        <div className="hero-grid">
          <div>
            <h1>Nurture Your<br />Heart and Grow<br />Together</h1>
            <p className="lead soft">Compassionate counselling for individuals, couples, and communities to foster healing and transformation.</p>
            <p><a className="btn" href="/book">Book a Session</a></p>
            <div className="cred">
              <div className="badge">ASCHP<br />REGISTERED</div>
              <div className="cred-card">
                <strong>Kgaugelo Paggy Tefo</strong>
                <span>Founder & Specialist Wellness Counsellor</span>
                <span>Membership No. 8806 | Registration No. SWC24/7080</span>
              </div>
            </div>
          </div>
          <div className="portrait-wrap">
            <div className="portrait-glow" />
            <img className="portrait" src="/founder.jpg" alt="Kgaugelo Paggy Tefo, founder of WarmNest Counselling" />
          </div>
        </div>
      </section>
      <section className="wrap-m center section">
        <h2>Welcome to WarmNest</h2>
        <p className="soft">At WarmNest, we believe healing happens in a space of warmth, trust, and gentle honesty. Whether you are navigating a moment of transition, walking through grief, or simply looking for support, you are met here with compassion and care.</p>
      </section>
      <section className="wrap" style={{ paddingBottom: "4rem" }}>
        <div className="cards-3">
          {focus.map((item) => (
            <article className="card center" key={item.title}>
              <div className="icon-bubble">{item.icon}</div>
              <h3>{item.title}</h3>
              <p className="muted" style={{ fontSize: "0.875rem" }}>{item.blurb}</p>
              <a className="link" href="/services">Learn more</a>
            </article>
          ))}
        </div>
      </section>
      <section className="wrap section">
        <h2 className="center">Our Services</h2>
        <div className="cards-3">
          {services.slice(0, 3).map((item) => (
            <article className={`tile ${item.tone}`} key={item.title}>
              <h3>{item.title}</h3>
              {item.icon}
              <p className="soft" style={{ fontSize: "0.875rem" }}>{item.blurb}</p>
            </article>
          ))}
        </div>
        <div className="cards-2" style={{ marginTop: "1.5rem", maxWidth: 720, marginInline: "auto" }}>
          {services.slice(3).map((item) => (
            <article className={`tile ${item.tone}`} key={item.title}>
              <h3>{item.title}</h3>
              {item.icon}
              <p className="soft" style={{ fontSize: "0.875rem" }}>{item.blurb}</p>
            </article>
          ))}
        </div>
      </section>
      <section className="wrap-s center section">
        <div className="quote-mark">"</div>
        <p className="quote">Healing does not happen in isolation. It happens in the quiet company of someone who truly sees you.</p>
        <p><a className="link" href="/book">Book your first session</a></p>
      </section>
    </>
  );
}
